<script setup>
const props = defineProps({
  iconName: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <a class="i-link" @click="startRefund">
    <svg v-if="iconName">
      <use :xlink:href="`#${iconName}`" />
    </svg>
    <slot />
  </a>
</template>

<style scoped lang="scss">
.i-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: $primary;

  svg {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  &:hover {
    color: $black;
  }

  &:visited {
    color: $gray;
  }

  &:focus {
    border: 2px solid $main;
  }

  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
